import { createSelector } from '@reduxjs/toolkit';
import { functionsNotDeleted } from './functions-not-deleted';

export const commonFunctionUuid = createSelector(functionsNotDeleted, (functions) => {
  const commonFunction = functions.filter((item) => item.templateId === 429)[0];
  if (commonFunction) {
    return commonFunction.uuid;
  }
});
